import { Outlet, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { HeaderNew } from '../components/home-new';
import { ProfileDrawerProvider } from '../context/ProfileDrawerContext';
import { NotificationProvider } from '../context/NotificationContext';

const HERO_BG_IMAGE = '/assets-new/MAM-background.png';

const NewPagesLayout = () => {
  const [bgImageLoaded, setBgImageLoaded] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/home-new';
  const isBookGoldPage = location.pathname === '/book-gold';
  const isRefundGoldPage = location.pathname === '/refund-gold';
  const isRedeemGoldPage = location.pathname === '/redeem-gold';
  const showFullBackground = isHomePage || isBookGoldPage || isRefundGoldPage || isRedeemGoldPage;

  useEffect(() => {
    // Preload background image
    const img = new Image();
    img.src = HERO_BG_IMAGE;
    img.onload = () => setBgImageLoaded(true);
  }, []);

  return (
    <ProfileDrawerProvider>
      <NotificationProvider>
        <div className="min-h-screen relative">
          {/* Background placeholder (light gold gradient) while image loads */}
          <div className="fixed inset-0 bg-gradient-to-r from-amber-50 to-amber-100 -z-20" />
          
          {/* Full-screen background image - fades in when loaded */}
          <div 
            className={`fixed inset-0 bg-cover bg-no-repeat -z-10 transition-opacity duration-500 ${bgImageLoaded ? 'opacity-100' : 'opacity-0'}`}
            style={{
              backgroundImage: `url(${HERO_BG_IMAGE})`,
              backgroundPosition: 'center center',
            }}
          />
          
          {/* Semi-transparent overlay for inner pages (not home or book-gold) for better readability */}
          {!showFullBackground && (
            <div className="fixed inset-0 bg-gradient-to-r from-white/50 to-amber-50/30 -z-10" />
          )}
          
          {/* Header - stays mounted across all pages */}
          <HeaderNew />
          
          {/* Page content - changes based on route */}
          <main className={`transition-opacity duration-300 ${bgImageLoaded ? 'opacity-100' : 'opacity-0'}`}>
            <Outlet />
          </main>
        </div>
      </NotificationProvider>
    </ProfileDrawerProvider>
  );
};

export default NewPagesLayout;
